/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { CoverageViewCorporationFragmentDoc } from './DocumentView/CoverageView.generated';
import { PamphletViewCorporationFragmentDoc } from './DocumentView/PamphletView.generated';
import { SalesMaterialViewSalesMaterialsFragmentDoc } from './DocumentView/SalesMaterialView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SolicitorCloudPageQueryVariables = Exact<{ [key: string]: never; }>;


export type SolicitorCloudPageQuery = { solicitorCloudCorporations: Array<{ id: string, name: string, documents: Array<
      | { __typename: 'SolicitorCloudCoverageDocument', id: string, title: string, createdAt: DateTimeString, updatedAt: DateTimeString, currentDocumentVersion: { id: string, publishedAt: DateTimeString } | null }
      | { __typename: 'SolicitorCloudPamphletDocument', id: string, title: string, createdAt: DateTimeString, updatedAt: DateTimeString, currentDocumentVersion: { id: string, publishedAt: DateTimeString } | null }
    > }>, solicitorCloudSalesMaterials: Array<{ id: string, title: string, pdfFilePath: string | null, youtubeUrl: string | null, publishedAt: DateTimeString, createdAt: DateTimeString, updatedAt: DateTimeString }> };


export const SolicitorCloudPageDocument = gql`
    query solicitorCloudPage {
  solicitorCloudCorporations {
    ...CoverageViewCorporation
    ...PamphletViewCorporation
  }
  ...SalesMaterialViewSalesMaterials
}
    ${CoverageViewCorporationFragmentDoc}
${PamphletViewCorporationFragmentDoc}
${SalesMaterialViewSalesMaterialsFragmentDoc}`;

/**
 * __useSolicitorCloudPageQuery__
 *
 * To run a query within a Vue component, call `useSolicitorCloudPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitorCloudPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSolicitorCloudPageQuery();
 */
export function useSolicitorCloudPageQuery(options: VueApolloComposable.UseQueryOptions<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables>(SolicitorCloudPageDocument, {}, options);
}
export function useSolicitorCloudPageLazyQuery(options: VueApolloComposable.UseQueryOptions<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables>(SolicitorCloudPageDocument, {}, options);
}
export type SolicitorCloudPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SolicitorCloudPageQuery, SolicitorCloudPageQueryVariables>;